import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from './supabase';
import { queryKeys } from './queries';

// Set a lot's FW Ready date. Direct jobs update under the admin RLS policy,
// the same path the notes cell uses.
export function useSetFwReady() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ jobId, fwReady }: { jobId: string; fwReady: string | null }) => {
            const { error } = await supabase
                .from('jobs')
                .update({ fw_ready_date: fwReady })
                .eq('id', jobId);
            if (error) throw error;
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: queryKeys.jobs.all });
        },
    });
}

/**
 * Mark that the builder has actually said flatwork is ready.
 *
 * This is a different fact from the FW Ready date. The date is when flatwork is
 * expected to be workable; this flag is the builder confirming it. Andrea does
 * both on her sheet today, a date in the cell and the community and lot turned
 * orange once the builder gives the word, and the board needs the same two
 * states or the colour has to be carried in her head.
 *
 * Setting it does not require a date, because the builder sometimes calls
 * before anyone has written one down.
 */
export function useSetFwReadyConfirmed() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ jobId, confirmed }: { jobId: string; confirmed: boolean }) => {
            const { error } = await supabase
                .from('jobs')
                .update({ fw_ready_confirmed: confirmed })
                .eq('id', jobId);
            if (error) throw error;
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: queryKeys.jobs.all });
        },
    });
}
